import React, {Fragment} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import PropTypes from 'prop-types';

import {showAlertModal} from "./../../../components/modal/AlertModal"


export const PUBLISHING_TEASER_MESSAGE = 'Publishing has not been activated for your Account. Please contact your Account Representative to activate.';
export const CANT_PUBLISH_MESSAGE = 'The provider does not support publishing to this post. Please contact your Account Representative for more information.';
let id = 0;

export class PublishingTeaserTooltip extends React.Component {

  static propTypes = {
    placement: PropTypes.string,
    hasPublishing: PropTypes.bool,
    cantBeRespondedTo: PropTypes.bool,
    children: PropTypes.any
  };

  id = id++;
  render() {
    const {cantBeRespondedTo, hasPublishing, placement, children} = this.props;

    if (!hasPublishing) {
      let elemId = "publishing-disabled-" + this.id;
      return <Fragment>
        <UncontrolledTooltip target={elemId} placement={placement}>{cantBeRespondedTo ? CANT_PUBLISH_MESSAGE : PUBLISHING_TEASER_MESSAGE}</UncontrolledTooltip>
        <div id={elemId}>
          {children}
        </div>
      </Fragment>
    } else {
      return children
    }
  }
}

export function showPublishingTeaserPopup () {
  showAlertModal({
      header: 'Not Enabled',
      message: PUBLISHING_TEASER_MESSAGE,
      icon: 'alert'
    })
}




